import { render, staticRenderFns } from "./signlist.vue?vue&type=template&id=bfef4cf4&scoped=true&"
import script from "./signlist.vue?vue&type=script&lang=js&"
export * from "./signlist.vue?vue&type=script&lang=js&"
import style0 from "./signlist.vue?vue&type=style&index=0&id=bfef4cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfef4cf4",
  null
  
)

export default component.exports